import React, { useEffect, useState } from 'react'
import './MassActionToolbar.scss'

/**
 * MassActionToolbar
 * Props:
 *  - visible (bool): controls visibility with enter (slide up) / exit (slide down) animation
 *  - onExited (func): called after exit animation finishes (so parent can actually unmount component)
 *  - children: custom toolbar content (fallback text if not provided)
 */
const EXIT_ANIMATION_MS = 300

const MassActionToolbar = ({ visible = true, onExited, children }) => {
  const [render, setRender] = useState(visible)
  const [stateClass, setStateClass] = useState('')

  // Handle visibility changes
  useEffect(() => {
    if (visible) {
      // Mount (if was unmounted) then trigger enter animation next tick
      setRender(true)
      requestAnimationFrame(() => setStateClass('mat-enter'))
    } else {
      // Trigger exit animation
      setStateClass('mat-exit')
      // After animation, unmount content and notify parent
      const timeout = setTimeout(() => {
        setRender(false)
        if (onExited) onExited()
      }, EXIT_ANIMATION_MS)
      return () => clearTimeout(timeout)
    }
  }, [visible, onExited])

  if (!render) return null

  return (
    <div className={`mass_action_toolbar ${stateClass}`}>
      {children}
    </div>
  )
}

export default MassActionToolbar